module.exports = __webpack_public_path__ + "4296dcf979a5e8362aff768feef8f456.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_10-mobile.png
// module id = 112
// module chunks = 1